import { Pipe, PipeTransform } from '@angular/core';
import { InputTypes } from '@shared/forms';

const VALID_TYPES = ['text', 'number', 'password'] as const;

@Pipe({
  name: 'fieldType',
})
export class FieldTypePipe implements PipeTransform {
  transform(value: string | null | undefined, fallback: InputTypes = 'text'): InputTypes {
    return (VALID_TYPES.includes(value as InputTypes) ? value : fallback) as InputTypes;
  }
}
